import dayjs from "@/lib/helpers/dayjs";
import type { PatientFile } from "@/features/patient/types/PatientFile";

export type FormattedFileRow = {
  fileName: string;
  loadDate: string;
};

export function formatFileRow(file: PatientFile): FormattedFileRow {
  const loadDate = dayjs.utc(file.timestamp).local().format("MM/DD/YYYY HH:mm");
  const fileName = file.file_key.substring(file.file_key.lastIndexOf("/") + 1);

  return { fileName, loadDate };
}
